export const openDropdowns: string[] = []
